import { TBaseUrl } from '@r1-frontend/do-request/core/types';

import getAccessToken from '@r1-frontend/shared/helpers/getAccessToken';
import { getAgreementNumber } from '@r1-frontend/shared/helpers/getAgreementNumber';
import getProviderId from '@r1-frontend/shared/helpers/getProviderId';
import { isServerSide } from '@r1-frontend/shared/helpers/ssr';
import { IRequest } from '@r1-frontend/shared/types/IRequest';

class BaseRequest {
    protected getDefaultHeaders(withAuth: IRequest['withAuth'], withProvider: IRequest['withProvider']): IRequest['headers'] {
        const defaultHeaders: IRequest['headers'] = {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        };

        const accessToken = getAccessToken();
        if (withAuth && Boolean(accessToken)) {
            defaultHeaders['Authorization'] = `Bearer ${accessToken}`;

            const agreementNumber = getAgreementNumber();
            if (agreementNumber) {
                defaultHeaders['agreementNumber'] = agreementNumber;
            }
        }

        if (withProvider) {
            defaultHeaders['ProviderId'] = getProviderId();
        }

        return defaultHeaders;
    }

    protected getBaseUrl(urls: TBaseUrl) {
        let url = urls.url;

        const innerUrl = urls.innerUrl;
        if (innerUrl && isServerSide()) {
            url = innerUrl;
        }

        if (!url) {
            throw new Error('Base url is not defined!');
        }

        return url;
    }
}

export default BaseRequest;
